import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";

const checkToken = () => localStorage.getItem("token") !== null;

const PrivateRoute = ({ children }) => {
   const location = useLocation();
    const params = new URLSearchParams(location.search);
    const tokenFromParams = params.get("token");
    const tour = params.get("tour");

    const decryptToken = (ciphertext) => {
      const secretKey = "e9w9r3q1w7d4f7t1g6c0s7v6c1x7z3b8m1y9e6a4q7e5t0r6n0l1p3u8a4z0h4!@#";
      const decodedCiphertext = decodeURIComponent(ciphertext);
      const bytes = CryptoJS.AES.decrypt(decodedCiphertext, secretKey);
      const originalToken = bytes.toString(CryptoJS.enc.Utf8);
      return originalToken;
  };
    if (tokenFromParams) {
      const decryptedToken = decryptToken(tokenFromParams);
      localStorage.setItem("token", decryptedToken);
  }
if(tour){
  localStorage.setItem("is_tour_complete",tour);
}
  return checkToken() ? children : <Navigate to="/auditor/auth/login" replace />; //replace =>  Replaces the current history entry (no "back" to the previous page) that means If the user is not authenticated, they get redirected to /login without being able to go back to the protected page by pressing the back button..
};

export default PrivateRoute;
